<template>
  <h2 class="bg-corepla-bg-light p-2">
    <slot />
  </h2>
</template>